import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  PIcon,
  PSelect,
  PSelectOption,
  PText,
} from '@porsche-design-system/components-react';
import { PSelectProps } from '@porsche-design-system/components-react/ssr';

export const LanguageSelect = ({
  label,
  disabled,
  value,
  locales,
  onChange,
}: {
  label: string;
  disabled?: boolean;
  value: string;
  locales: { name: string; code: string; isDefault?: boolean }[];
  onChange: (code: string) => void;
}) => {
  return (
    <Container>
      <PText size="sm">{label}</PText>
      <PIcon name="globe" />
      <PSelect
        compact
        hideLabel
        label={label}
        aria-label={label}
        disabled={disabled}

        name="language"
        value={value}
        onChange={(e) => {
          const { value: selectedValue } = e.target as HTMLElement &
            PSelectProps;
          onChange(String(selectedValue));
        }}
      >
        {locales.map(({ name, code }) => (
          <PSelectOption value={code} key={code}>
            {name}
          </PSelectOption>
        ))}
      </PSelect>
    </Container>
  );
};

const Container = styled('div', {
  base: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: 'auto auto 1fr',
    gap: '8px',
    width: '300px',
  },
});
